export default __webpack_public_path__ + "static/media/work-learn.culinary-arts.9cfe084d.png";